import { useEffect, useState } from 'react';
import './ScrollToTopButton.scss';

type ScrollToTopButtonProps = {
    section?: string;
}

const ScrollToTopButton = ({ section }: ScrollToTopButtonProps) => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        setVisible(scrolled > 400)
    };

    const scrollToTop = () => {

        if (section) {
            const element = document.getElementById(section);
            if (element) {
                const rect = element.getBoundingClientRect();
                if (rect.top < 0) {
                    // Get the height of the header
                    const headerHeight = document.querySelector('.platform-header')?.clientHeight || 0;

                    // Scroll to the element, accounting for the header height
                    window.scroll({
                        top: rect.top + window.scrollY - headerHeight,
                        behavior: 'smooth',
                    });
                    return;
                }
            }
        }

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisible);

        return () => {
            window.removeEventListener('scroll', toggleVisible);
        };
    }, []);

    return (
        <button tabIndex={-1} onClick={scrollToTop} className={`scroll-to-top ${visible ? '' : 'd-none'}`}>
            <i className="fas fa-chevron-up fa-xl"></i>
        </button>
    );
}

export default ScrollToTopButton; 